(function () {
  function initAutoRotate(comp) {
    if (comp.__autoRotateInit) return;
    comp.__autoRotateInit = true;

    const speed = (parseFloat(comp.dataset.speed) || 5) * 1000;
    const nextBtn = comp.querySelector('.slider-button--next');
    if (!nextBtn) return;

    let timer = null;
    const start = function () {
      stop();
      timer = setInterval(function () {
        if (document.visibilityState === 'hidden') return;
        nextBtn.click();
      }, speed);
    };
    const stop = function () {
      if (timer) clearInterval(timer);
      timer = null;
    };

    comp.addEventListener('mouseenter', stop);
    comp.addEventListener('mouseleave', start);
    comp.addEventListener('focusin', stop);
    comp.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') stop();
      else start();
    });

    start();
  }

  function run() {
    document
      .querySelectorAll('slider-component[data-autoplay="true"]')
      .forEach(initAutoRotate);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
